import Section from "../components/Section";

export default function Support() {
  return (
    <Section
      eyebrow="Support"
      title="Helplines & Organizations"
      subtitle="Reach out to trusted NGOs, hospitals, and national programs for guidance and treatment."
    >
      <ul className="space-y-3">
        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Thalassemics India
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://www.thalassemicsindia.org"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            DKMS Foundation India – Thalassemia Program
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://www.dkms-india.org/get-involved/programs/thalassemia-program"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Thalassaemia and Sickle Cell Society (TSCS), Hyderabad
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://www.tscsindia.org"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Blood Warriors Foundation
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://www.bloodwarriors.in"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Thalassaemia Society of India
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://thalassaemiasociety.org"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Thalassemia Bal Sewa Yojana (Govt. of India)
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://www.india.gov.in/information-thalassemia-bal-sewa-yojana"
            target="_blank"
            rel="noreferrer"
          >
            Learn More →
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            National Health Helpline (India)
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="tel:1075"
          >
            Call 1075
          </a>
        </li>

        <li className="rounded-xl border p-5 bg-white shadow-sm">
          <div className="font-semibold text-slate-900">
            Find Nearest Blood Bank (NACO Directory)
          </div>
          <a
            className="text-rose-700 hover:underline"
            href="https://naco.gov.in/blood-bank-directory"
            target="_blank"
            rel="noreferrer"
          >
            Search Directory →
          </a>
        </li>
      </ul>
    </Section>
  );
}
